import { mergeClass } from "../utils";

export const Loader = () => (
  <div
    className="place-self-center inline-block h-8 w-8 animate-spin rounded-full border-4 border-solid border-current border-r-transparent align-[-0.125em] motion-reduce:animate-[spin_1.5s_linear_infinite]"
    role="status"
  >
    <span className="!absolute !-m-px !h-px !w-px !overflow-hidden !whitespace-nowrap !border-0 !p-0 ![clip:rect(0,0,0,0)]">
      Loading...
    </span>
  </div>
);

export const Spinner = ({ className }: { className?: string }) => (
  <div
    className={mergeClass(
      "inline-block h-5 w-5 animate-spin rounded-full border-2 border-solid border-current opacity-50 border-r-transparent align-[-0.125em] motion-reduce:animate-[spin_1.5s_linear_infinite] place-self-center",
      className
    )}
  />
);
